const coursemap = angular.module("coursemap")

function signupCtrl() {}

signupCtrl.$inject = []

coursemap.controller("signupCtrl", signupCtrl)
